enum SortDirection {
  'ASC' = 1,
  'DESC' = -1,
}

export default SortDirection
